//export const API_URL = 'http://localhost:8080'
export const API_URL = 'https://sotoemp-api.sotorestaurant.com';
//export const REDIRECT_URL = 'http://localhost:3000/handle'
export const REDIRECT_URL = 'https://tips.sotorestaurant.com/handle';
